import Api from './Api'

export default {

    liste() {
        return Api().get('roles/usable')
    }
}